const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.us.forwood.one',
    USER_TOKEN_URL: 'https://i3nmk88ik1.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://r2rl14t3aa.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.us.forwood.one',
    COMPANY_MICROFRONTEND_URL: 'https://company.us.forwood.one',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.us.forwood.one'
  },
  configurationService: {
    URL: 'https://config.us.forwood.one',
    WEBSOCKET: 'wss://worao5bibi.execute-api.us-west-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
